import type { SVGProps } from "react";
export interface MoneyBillWavyDollarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MoneyBillWavyDollarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MoneyBillWavyDollarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 16.732V5.78l-.002-.022-.146-.05A12 12 0 0 0 17 5.125c-1.816 0-3.425.453-5.043.95-1.561.48-3.25 1.05-4.957 1.05-.811 0-1.587-.08-2.341-.219l-.747-.156c-.363-.086-.6-.141-.777-.173-.007.155-.01.367-.01.69V18.01l.001.208v.022l.147.052.318.098c.796.235 1.977.484 3.409.485 1.816 0 3.426-.453 5.044-.951 1.561-.48 3.248-1.05 4.956-1.05 1.081 0 2.1.143 3.088.376.361.085.6.138.776.17.007-.156.01-.368.01-.689Zm2.25 0c0 .36.001.699-.021.974-.02.24-.063.548-.21.852l-.073.13a2.06 2.06 0 0 1-.99.863l-.184.067c-.393.126-.779.085-1.05.043-.287-.045-.64-.13-1.025-.22A11 11 0 0 0 17 19.125c-1.292 0-2.604.43-4.293.95-1.632.502-3.524 1.05-5.707 1.05-1.689 0-3.087-.293-4.048-.577l-.385-.12c-.206-.068-.502-.155-.8-.364l-.127-.099a2.25 2.25 0 0 1-.617-.852 2.4 2.4 0 0 1-.148-.873V7.267c0-.36 0-.699.022-.975.022-.273.075-.636.281-.98l.109-.164a2.06 2.06 0 0 1 1.066-.766l.147-.04c.34-.075.665-.04.903-.002.287.045.639.129 1.024.22l.637.133A10.7 10.7 0 0 0 7 4.875c1.291 0 2.605-.43 4.294-.95 1.632-.502 3.523-1.05 5.706-1.05 1.93 0 3.48.382 4.433.697l.197.065c.18.062.391.15.604.3l.126.098.189.18c.12.131.23.281.316.437l.112.236.054.155c.076.258.09.508.094.716z"
      />
      <path
        fill={color}
        d="M4.375 13.5v-1a1.125 1.125 0 0 1 2.25 0v1a1.125 1.125 0 0 1-2.25 0m13-2v-1a1.125 1.125 0 0 1 2.25 0v1a1.125 1.125 0 0 1-2.25 0m-6.079-1.215a.2.2 0 0 0 .006.05h.002l.001.003a.4.4 0 0 0 .062.056c.133.097.4.21.854.3 1.237.247 2.732 1.106 2.732 2.83 0 1.23-.781 2.224-1.842 2.64a1.123 1.123 0 0 1-2.22.024 2.9 2.9 0 0 1-1.714-1.608l-.072-.193-.03-.112a1.124 1.124 0 0 1 2.123-.706l.041.107.032.075c.04.076.1.154.185.218.104.078.273.155.545.155.453 0 .701-.324.702-.6 0-.096-.029-.182-.148-.289a1.4 1.4 0 0 0-.514-.268l-.261-.067c-.563-.113-1.211-.304-1.737-.687-.584-.425-.997-1.076-.997-1.937q0-.053.006-.105v-.003h.002c.046-1.16.851-1.984 1.835-2.342a1.125 1.125 0 0 1 2.218-.013 2.9 2.9 0 0 1 1.789 1.8 1.126 1.126 0 0 1-2.135.712.63.63 0 0 0-.217-.295c-.103-.078-.271-.155-.543-.155a.9.9 0 0 0-.574.185c-.113.094-.129.174-.13.213v.012Z"
      />
    </svg>
  );
}
